import { SyntheticEvent, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Cookies from 'universal-cookie';

import { UseGetFlag } from "../app/launchDarkly";
import { useAppSelector } from "../app/store/hooks";
import LoadingUpAnimation from "../components/LoadingUpAnimation";
import useHomePageJson from "../components/newHomePage/utils/useHomePageJson";
import usePostHogRecordingGlobal from "../hooks/usePostHogRecordingGlobal";
import { MealPlanActive, MealPlanInactive } from "../iconRef/mealPLanIcons";
import { ReactComponent as AccountIcon } from "../svg/menuIcons/accountIcon.svg"
import { ReactComponent as AccountIconActive } from "../svg/menuIcons/accountIconActive.svg"
import { ReactComponent as SearchIcon } from "../svg/menuIcons/searchIcon.svg"
import { ReactComponent as SearchIconActive } from "../svg/menuIcons/searchIconActive.svg"
import { HomeIconActive, HomeIconInActive } from "../utils/iconRefs/homePageIcons";
import { appStore } from "../utils/os.utils";
import MainPage from "./mainPage";
import MealPlan from "./mealPlan/MealPlan";
import styles from "./privateHomePage.module.css";
import ProfilePage from "./profilePage";
import SearchPage from "./searchPage";

let deferredPrompt: any;
let cookieFlag: any;
let fullscreenFlag: boolean;

const TabPanel = (props: any) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            aria-labelledby={`simple-tab-${index}`}
            className="tabpanelClass"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            role="tabpanel"
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

const homepageRoute = {
    home: '/',
    explore: '/explore',
    account: '/account',
    mealPlan: '/meal-plan',
}

const PrivateHomePage = ({ defaultTabIndex }: { defaultTabIndex: number }) => {
    const { enableMealPlan } = UseGetFlag()
    const history = useHistory();
    const [mealPlanTempDefaultIndexhandler, setCurrentTabIndex] = useState<number>(defaultTabIndex || 0);
    const currentTabIndex = !enableMealPlan && mealPlanTempDefaultIndexhandler === 3 ? 2 : mealPlanTempDefaultIndexhandler;
    const cookies = new Cookies();
    const refetchJson = useAppSelector((state) => state.homepage.refetchJson);
    const recipeList = useAppSelector((state) => state.homepage.recipeList);

    const { homeConfig, loading } = useHomePageJson(refetchJson);
    const posthogRec = usePostHogRecordingGlobal(currentTabIndex)

    useEffect(() => {
        cookieFlag = cookies.get('InstallMessage')
        fullscreenFlag = window.matchMedia('(display-mode: fullscreen)').matches

        const beforeInstallPromptListener = (e: any) => {
            e.preventDefault();
            deferredPrompt = e;
        }
        window.addEventListener("beforeinstallprompt", beforeInstallPromptListener);

        const cleanUpListeners = () => {
            window.removeEventListener("beforeinstallprompt", beforeInstallPromptListener);
        };

        if (fullscreenFlag) {
            return cleanUpListeners;
        }
        return cleanUpListeners;

    }, []);

    const handleInstallClick = () => {

        appStore()
    };

    const handleChange = (event: SyntheticEvent<Element, Event>, newValue: number) => {
        setCurrentTabIndex(newValue);
    };

    if (loading && recipeList.length === 0) return <LoadingUpAnimation />

    return (
        <>
            <Box
            >
                <TabPanel index={0} value={currentTabIndex}>
                    <MainPage homeConfig={homeConfig} />
                </TabPanel>
                <TabPanel index={1} value={currentTabIndex}>
                    <SearchPage />
                </TabPanel>
                {enableMealPlan ? <TabPanel index={2} value={currentTabIndex}>
                    <MealPlan />
                </TabPanel> : null}
                <TabPanel index={enableMealPlan ? 3 : 2} value={currentTabIndex}>
                    <ProfilePage fullscreenFlag={fullscreenFlag} handleInstallClick={handleInstallClick} />
                </TabPanel>
                <Tabs className={styles.tabs_bar} key={currentTabIndex} onChange={handleChange}
                    value={currentTabIndex}>
                    <Tab
                        className={currentTabIndex === 0 ? styles.tab_bar_icon_active : styles.tab_bar_icon}
                        icon={currentTabIndex === 0 ? <HomeIconActive /> : <HomeIconInActive />}
                        label="Home"
                        onClick={() => history.push(homepageRoute.home)}
                    />
                    <Tab
                        className={currentTabIndex === 1 ? styles.tab_bar_icon_active : styles.tab_bar_icon}
                        icon={currentTabIndex === 1 ? <SearchIconActive /> : <SearchIcon />}
                        label="Explore"
                        onClick={() => history.push(homepageRoute.explore)}

                    />
                    {enableMealPlan ? <Tab
                        icon={currentTabIndex === 2 ? <MealPlanActive /> : <MealPlanInactive />}
                        label="Planner"
                        onClick={() => history.push(homepageRoute.mealPlan)}
                        sx={{

                            fontSize: '12px',
                            fontWeight: 600,
                            px: 0,
                            py: 1,
                            color: currentTabIndex === 2 ? '#3B1F8E !important' : '#A0A0A0 !important',
                            minHeight: 'fit-content !important'
                        }}
                    /> : null}
                    <Tab
                        icon={currentTabIndex === (enableMealPlan ? 3 : 2) ? <AccountIconActive /> : <AccountIcon />}
                        label="Account"
                        onClick={() => history.push(homepageRoute.account)}
                        sx={{

                            fontSize: '12px',
                            fontWeight: 600,
                            px: 0,
                            py: 1,
                            color: currentTabIndex === 3 ? '#3B1F8E !important' : '#A0A0A0 !important',
                            minHeight: 'fit-content !important'
                        }}
                    />
                </Tabs>
            </Box>
        </>
    );
};

export default PrivateHomePage;